import React from "react";
import Section1 from "../Components/Section1";
import Section2 from "../Components/Section2";
import Section3 from "../Components/Section3";
import { motion } from "framer-motion";

const Home = () => {
  return (
    <div>
      <motion.div
        // className="container "
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        exit={{ opacity: 0 }}
        transition={{ duration: 0.5 }}
      >
        <Section1 />
        <Section2 />
        <Section3 />
      </motion.div>
    </div>
  );
};

export default Home;
